import { createSlice } from '@reduxjs/toolkit';

export const reservationSlice = createSlice({
    name: 'reservation',
    initialState: {
        dataToAction: { intention: '', amount: '', whoInvests: '', comments: '' }
    },
    reducers: {
        selectReservation: (state, {payload}) => {
            state.dataToAction = payload;
        },
        unSelectReservation: (state) => {
            state.dataToAction = {
                userToAction: { intention: '', amount: '', whoInvests: '', comments: '' }
            }
        }
    }
});

export const { selectReservation, unSelectReservation } = reservationSlice.actions;